import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, Outlet, useLocation } from "react-router-dom";
import "../../css/Admin.css";

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [hoverMode, setHoverMode] = useState(false); // ✅ added
  const [role, setRole] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState({
    dashboard: false,
    users: false,
    settings: false,
    hrm: false,
    employees: false,
    purchase: false,
    sales: false,
    archive: false,
    settings: false,
  });

  useEffect(() => {
    const savedRole = localStorage.getItem("adminRole");
    if (!savedRole) {
      navigate("/admin-login");
    } else {
      setRole(savedRole);
    }
  }, [navigate]);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => {
      const newState = !prev;
      setHoverMode(false); // ✅ Disable hoverMode on manual toggle
      return newState;
    });
  };

  const toggleDropdown = (menu) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  const handleLogout = () => {
    localStorage.removeItem("adminAuthToken");
    localStorage.removeItem("adminRole");
    localStorage.removeItem("adminName");
    navigate("/admin-login");
  };

  const handleMouseEnter = () => {
    if (!sidebarOpen) {
      setSidebarOpen(true);
      setHoverMode(true); // ✅ only enable hoverMode when sidebar was closed
    }
  };

  const handleMouseLeave = () => {
    if (hoverMode) {
      setTimeout(() => {
        setSidebarOpen(false);
        setHoverMode(false);
      }, 300); // ✅ smooth close
    }
  };

  return (
    <div className="admin-container">
      <div
        className={`sidebar ${sidebarOpen ? "open" : "closed"}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="site-logo">
          <NavLink to="/admin-dashboard">
            <img src="/images/site-logo.png" alt="Site Logo" />
          </NavLink>
        </div>

        <div className="bottom-side-wrapper">
          <ul>
            <li>
              <NavLink
                to="/admin-dashboard"
                end
                className={({ isActive }) =>
                  `sidebar-link${isActive ? " active" : ""}`
                }
              >
                <i className="fas fa-tachometer-alt icon"></i>
                {sidebarOpen && "Dashboard"}
              </NavLink>
            </li>

            {(role === "3" || role === "1") && (
              <li onClick={() => toggleDropdown("hrm")}>
                <div className="item-menus">
                  <i className="fas fa-briefcase icon"></i>
                  {sidebarOpen && (
                    <div className="menu-label-wrapper">
                      <span>HRM</span>
                      {dropdownOpen.hrm ? (
                        <i className="fa-solid fa-chevron-down"></i>
                      ) : (
                        <i className="fa-solid fa-chevron-right"></i>
                      )}
                    </div>
                  )}
                </div>
                {dropdownOpen.hrm && sidebarOpen && (
                  <ul className="submenu" onClick={(e) => e.stopPropagation()}>
                    <div
                      className="dropsubmenu"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleDropdown("employees");
                      }}
                    >
                      <div className="menu-label-wrapper item-menus">
                        <span>
                          <i className="fa-solid fa-users icon"></i>Employees
                        </span>
                        {dropdownOpen.employees ? (
                          <i className="fa-solid fa-chevron-down"></i>
                        ) : (
                          <i className="fa-solid fa-chevron-right"></i>
                        )}
                      </div>
                    </div>
                    {dropdownOpen.employees && (
                      <ul
                        className="submenu nested-submenu"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <li>
                          <NavLink
                            to="employee-list"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <i className="fas fa-user icon"></i>Employee
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="add-employee"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <i className="fa-solid fa-user-plus icon"></i>Add
                            Employee
                          </NavLink>
                        </li>
                      </ul>
                    )}
                    <li>
                      <NavLink
                        to="employee-attendances"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <i className="fas fa-calendar-check icon"></i>
                        Attendance
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="meetings-list"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <i className="fa-solid fa-handshake icon"></i>Meeting
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="employee-location"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <i className="fa-solid fa-location-dot icon"></i>
                        Employee Location
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        to="employee-route"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <i className="fa-solid fa-location-dot icon"></i>
                        Live Location
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        to="attendance-view"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <i className="fa-regular fa-eye icon"></i>Attendance
                        View
                      </NavLink>
                    </li>

                     <li>
                      <NavLink
                        to="leave-details"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <i class="fas fa-bed icon"></i>Leave Details
                      </NavLink>
                    </li>

                      <li>
                      <NavLink
                        to="app-id"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <i class="fas fa-fingerprint icon"></i>App Id
                      </NavLink>
                    </li>

                  </ul>
                )}
              </li>
            )}

            {(role === "7" || role === "1") && (
              <li onClick={() => toggleDropdown("purchase")}>
                <div className="item-menus">
                  <i className="fas fa-shopping-cart icon"></i>
                  {sidebarOpen && (
                    <div className="menu-label-wrapper">
                      <span>Purchase</span>
                      {dropdownOpen.purchase ? (
                        <i className="fa-solid fa-chevron-down"></i>
                      ) : (
                        <i className="fa-solid fa-chevron-right"></i>
                      )}
                    </div>
                  )}
                </div>
                {dropdownOpen.purchase && sidebarOpen && (
                  <ul className="submenu" onClick={(e) => e.stopPropagation()}>
                    <li>
                      <NavLink
                        to="purchase"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <i className="fas fa-clipboard-list icon"></i>Add
                        Purchase
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="purchase-details"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <i className="fas fa-cash-register icon"></i>Purchase
                        Details
                      </NavLink>
                    </li>
                  </ul>
                )}
              </li>
            )}

            {(role === "8" || role === "1") && (
              <li onClick={() => toggleDropdown("sales")}>
                <div className="item-menus">
                  <i className="fas fa-shopping-bag icon"></i>
                  {sidebarOpen && (
                    <div className="menu-label-wrapper">
                      <span>Sales</span>
                      {dropdownOpen.sales ? (
                        <i className="fa-solid fa-chevron-down"></i>
                      ) : (
                        <i className="fa-solid fa-chevron-right"></i>
                      )}
                    </div>
                  )}
                </div>
                {dropdownOpen.sales && sidebarOpen && (
                  <ul className="submenu" onClick={(e) => e.stopPropagation()}>
                    <li>
                      <NavLink
                        to="distributor-details"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <i className="fas fa-store icon"></i>Distributor Details
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="order-details"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <i className="fa fa-check-circle icon"></i>Order Details
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="farmer-details"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <i class="fas fa-seedling icon"></i>Farmer Details
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="dealer-details"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <i class="fas fa-user-tie icon"></i>Dealer Details
                      </NavLink>
                    </li>
                  </ul>
                )}
              </li>
            )}

            {role === "1" && (
              <li onClick={() => toggleDropdown("archive")}>
                <div className="item-menus">
                  <i className="fa-solid fa-box-archive icon"></i>
                  {sidebarOpen && (
                    <div className="menu-label-wrapper">
                      <span>Archive</span>
                      {dropdownOpen.archive ? (
                        <i className="fa-solid fa-chevron-down"></i>
                      ) : (
                        <i className="fa-solid fa-chevron-right"></i>
                      )}
                    </div>
                  )}
                </div>
                {dropdownOpen.archive && sidebarOpen && (
                  <ul className="submenu" onClick={(e) => e.stopPropagation()}>
                    <li>
                      <NavLink
                        to="archived-employees"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <i className="fa-solid fa-users-slash icon"></i>
                        Employee
                      </NavLink>
                    </li>
                  </ul>
                )}
              </li>
            )}

{role === "1" && (
  <li onClick={() => toggleDropdown("settings")}>
    <div className="item-menus">
      <i className="fas fa-cog icon"></i>
      {sidebarOpen && (
        <div className="menu-label-wrapper">
          <span>Settings</span>
          {dropdownOpen.settings ? (
            <i className="fa-solid fa-chevron-down"></i>
          ) : (
            <i className="fa-solid fa-chevron-right"></i>
          )}
        </div>
      )}
    </div>
    {dropdownOpen.settings && sidebarOpen && (
      <ul className="submenu" onClick={(e) => e.stopPropagation()}>
        <li>
          <NavLink
            to="api-key"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <i className="fas fa-key icon"></i>API Key
          </NavLink>
        </li>
      </ul>
    )}
  </li>
)}



          </ul>
        </div>
      </div>

      <div
        className={`main-content ${
          sidebarOpen ? "with-sidebar" : "full-width"
        }`}
      >
        <div className="bottom-wrapper">
          <div className="top-header">
            <div className="left-side">
              <button className="toggle-button" onClick={toggleSidebar}>
                {sidebarOpen ? (
                  <i className="fa-solid fa-xmark"></i>
                ) : (
                  <i className="fa-solid fa-bars"></i>
                )}
              </button>
            </div>
            <div className="right-side">
              <div className="profile">
                <img src="/images/p-1.png" alt="admin" />{" "}
                {localStorage.getItem("adminName")}
              </div>
              <div className="logout-btn">
                <button onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt icon"></i> Logout
                </button>
              </div>
            </div>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
